module.exports = __webpack_public_path__ + "static/img_a.5c0a1416.png";